export default `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 130 130">
  <path id="iconmonstr-email-10" d="M65,.02a65,65,0,1,0,65,65,65,65,0,0,0-65-65Zm37.863,37.808L65,68.519,27.132,37.828h75.73Zm.054,54.167H27.083V45.926L65,76.655l37.917-30.723Z" transform="translate(0 -0.02)" fill="#9b9b9b"/>
</svg>
`
